import { memo } from "react";
import { colors, css, useMediaQuery, frames, glyphs } from "../../Styles"
import NewButton, { NewButtonList } from "./newButton";
import { ButtonTypes, ListStyle_Types, NewFieldStyles, NewFieldTypes, SelectFieldOption_Values } from "../../Definitions";
import NewSelect from "./newSelect";

// #region | PageHeader Component
interface pageHeader_Props {
  topHeader?: string
  subHeader?: string
  zIndex?: number
  optionButtons?: {
    contents: string[];
    onClick: (i: number) => void;
  }
  subContent?: JSX.Element;
  subSelect?: {
    options: SelectFieldOption_Values[];
    onChange: ((selectedOption: SelectFieldOption_Values | undefined) => void) | undefined
    onNext?: () => void;
    onPrev?: () => void;
    defaultValue: SelectFieldOption_Values | undefined;
    disabled?: boolean
  }
}
/**
 * PageHeader
 * @param topHeader "h1" title on page.
 * @param subHeader "h2" title on page.
 * @returns topHeader and subHeader.
 */
function PageHeader({ topHeader, subHeader, zIndex, optionButtons, subSelect, subContent }: pageHeader_Props) {
  const hideBtns = useMediaQuery(`(max-width: 700px)`);
  
  return (
    <frames._page_inner_header style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", zIndex: zIndex ? zIndex : 0}}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
        <p style={{ ...css.topHeader }}>{topHeader}</p>
        { subHeader && <p style={{ ...css.subHeader }}>{subHeader}</p> }
        { subSelect && <div style={{ display: "flex", gap: "6px" }}>
          <NewSelect
            options={subSelect.options}
            fieldOverrides={{
              fieldType: NewFieldTypes.primaryField,
              fieldStyle: NewFieldStyles.greyDarkPrimary,   
              fieldWidth: "230px"
            }}
            onChange={subSelect.onChange}  
            isSearchable
            isDisabled={subSelect.disabled}
            valueOverrides={{ defaultValue: subSelect.defaultValue }}
          />
          {subSelect.onNext !== undefined && subSelect.onPrev !== undefined && <div style={{display: "flex", gap: "4px"}}>
            <NewButton
              content=""
              buttonType={ButtonTypes.arrowButton}
              startEnhancer={glyphs.Arrow({rotate: 180})}
              onClick={subSelect.onPrev}
            /> 
            <NewButton
              content=""
              buttonType={ButtonTypes.arrowButton}
              startEnhancer={glyphs.Arrow({})}
              onClick={subSelect.onNext}
            /> 
          </div>}
        </div>
        }
      </div>

      { optionButtons && <div style={{}}>
        <NewButtonList
          contents={optionButtons.contents} 
          onClick={(i => {
            if (optionButtons.onClick) optionButtons.onClick(i);
          })}
          buttonType={hideBtns ? ButtonTypes.glyphButton : ButtonTypes.primaryButton}
          overrides={{
            baseStyles: { ...( !hideBtns ? { width: "fit-content", minWidth: "none" } : {backgroundColor: colors.greyDarkSecondary})},
          }}
          listOverrides={{
            listStyle: !hideBtns ? ListStyle_Types.horizontal : ListStyle_Types.vertical,
          }}
          popOverrides={{
            hasPop: !hideBtns ? false : true,
            popoverStyle: { backgroundColor: colors.greyDarkPrimary, padding: "20px", borderRadius: "10px", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d" },
            openContent: "",
            buttonType: ButtonTypes.primaryButton,
          }}              
        />
      </div>}
      
      {subContent && subContent} 
    </frames._page_inner_header>
  )
} 

export default memo(PageHeader);